import { get } from "lodash";
import { useUserPerson } from "src/contexts/global/GlobalContext";
import { getDefaultRoutePath } from "src/util/routing";
import {
  useWorkspace,
  useWorkspaceFeatureFlags,
} from "src/contexts/global/WorkspaceContext";
import { useOrgDesignBetaEnabled } from "src/components/OrgChart/controller/dnd/featureFlags";
import useIsDesignWorkspace from "src/pages/Workspaces/components/WorkspaceAccess/useIsDesignWorkspace";
import useRestricted from "./useRestricted";

const useDefaultRoutePath = () => {
  const [isRestricted] = useRestricted();
  const userPerson = useUserPerson();
  const workspace = useWorkspace();
  const { disablePersonalisation } = useWorkspaceFeatureFlags();
  const isOrgDesignBetaEnabled = useOrgDesignBetaEnabled();

  const userId = disablePersonalisation ? null : get(userPerson, "aggregateId");
  // Independent of disablePersonalisation, unlike `userId` above - matches
  // the raw "has a Person record" signal getRoutes gates ORG_DESIGN_HOME on.
  const hasPerson = Boolean(get(userPerson, "aggregateId"));

  // Only look the workspace up when the answer could change the route.
  const { isDesignWorkspace, loading: isDesignWorkspaceLoading } =
    useIsDesignWorkspace(
      !hasPerson && isOrgDesignBetaEnabled ? workspace?.id : undefined
    );

  const defaultRoutePath = getDefaultRoutePath({
    userId,
    hasPerson,
    isRestricted,
    isOrgDesignBetaEnabled,
    // Optimistic while loading: the app-root redirect fires on first render,
    // so answering "no" here would strand a provisioned workspace's users on
    // Teams. HomePageContainer redirects away once the lookup says no.
    isDesignWorkspace: isDesignWorkspaceLoading || isDesignWorkspace,
  });

  return defaultRoutePath;
};

export default useDefaultRoutePath;
